document.addEventListener('DOMContentLoaded', () => {
  const scrollButtons = document.querySelectorAll('.btn--scroll');

  /**
   * Smooth scroll to the target section with an offset from the top.
   *
   * @param {Event} event - The click event.
   */
  function smoothScroll(event) {
    event.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  scrollButtons.forEach(function (button) {
    button.addEventListener('click', smoothScroll);
  });
});
